export const trackEvent = (category, action, label, value) => {
  if ("ga" in window) {
    let tracker = window.ga.getAll()[0];
    if (tracker) {
      tracker.send("event", category, action, label, value);
    }
  }
};
